import {UserResource} from '@services/resource/user-resource';
import {Startup} from '@services/model/startup';
import {UserType} from '@services/resource/user-type';
import {Title} from '@services/resource/title';
import {UUID} from '@util/types';
import moment, {Moment} from 'moment';
import {UserPrivilege} from '@services/resource/user-privilege';

export class UserSearchResult {
  constructor(
    public readonly total: number,
    public readonly users: User[],
  ) {}

  static fromResource(r: UserSearchResultResource) {
    return new UserSearchResult(r.total, r.users.map(User.fromResource));
  }
}

export interface UserSearchResultResource {
  total: number;
  users: UserResource[];
}

export class User {
  constructor(
    public readonly id: string,
    public readonly email: string,
    public readonly title: Title,
    public readonly firstName: string,
    public readonly lastName: string,
    public readonly userType: UserType,
    public readonly phone: string,
    public readonly permissions: string[],
    public readonly companyId: UUID,
    public readonly mnetId: string,
    public readonly userPrivilege: UserPrivilege,
    public readonly startup?: Startup,
    public readonly lastSeen?: Moment,
  ) {}

  public static fromResource(r: UserResource) {
    return new User(
      r.id,
      r.email,
      r.title,
      r.firstName,
      r.lastName,
      r.userType,
      r.phone,
      r.permissions,
      r.companyId,
      r.mnetId,
      r.userPrivilege,
      r.startup ? Startup.fromResource(r.startup) : undefined,
      moment(r.lastSeen),
    );
  }

  public static toResource(u: User): UserResource {
    return {...u, startup: undefined, lastSeen: undefined};
  }

  public static hasVotingPermission(u: User): boolean {
    if (!u || !u.permissions) {
      return false;
    }
    return u.permissions.indexOf('vote') >= 0;
  }

  public static hasPrivilege(u: User): UserPrivilege {
    return u.userPrivilege;
  }
}
